import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function ProjectsPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useState(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  const projects = [
    {
      id: 1,
      title: 'إنشاء غرفة مقاومة للحريق - مصرف الراجحي',
      category: 'الترميم والإنشاءات',
      location: 'الرياض - مخرج 16',
      area: '900 متر مربع',
      description: 'إنشاء غرفة بمساحة 900 م² مقاومة للحريق في مستودعات مصرف الراجحي شاملة لجميع الأعمال الميكانيكية والكهربائية والمدنية',
      image: 'https://public.readdy.ai/ai/img_res/3b2e5912cc2a1df528da154d5d6b606f.jpg',
      slug: 'fireproof-room-alrajhi'
    },
    {
      id: 2,
      title: 'ترميم غرفة الصرافة - مصرف الراجحي',
      category: 'الترميم والصيانة',
      location: 'الرياض',
      area: 'ترميم كامل',
      description: 'ترميم وصيانة غرفة صرافة بالرياض بالكامل خاصة بمصرف الراجحي شاملة جميع الأعمال المدنية والكهربائية',
      image: 'https://readdy.ai/api/search-image?query=Bank%20teller%20room%20renovation%20project%2C%20modern%20banking%20facility%20interior%20with%20professional%20finishes%2C%20complete%20renovation%20of%20commercial%20banking%20space%2C%20corporate%20construction%20photography%20with%20clean%20professional%20style&width=800&height=600&seq=project-teller-renovation-002&orientation=landscape',
      slug: 'teller-room-renovation'
    },
    {
      id: 3,
      title: 'ترميم دورات المياه - فرع الكعكية',
      category: 'الترميم والصيانة',
      location: 'مكة المكرمة - الكعكية',
      area: 'ترميم شامل',
      description: 'ترميم وصيانة دورات مياه بالكامل داخل فرع الكعكية مكة المكرمة مصرف الراجحي',
      image: 'https://readdy.ai/api/search-image?query=Modern%20bathroom%20renovation%20in%20commercial%20building%2C%20elegant%20restroom%20facilities%20with%20contemporary%20fixtures%2C%20complete%20bathroom%20renovation%20with%20high-quality%20finishes%2C%20corporate%20construction%20photography%20with%20professional%20quality&width=800&height=600&seq=project-bathroom-renovation-003&orientation=landscape',
      slug: 'bathroom-renovation-kakiya'
    },
    {
      id: 4,
      title: 'أنظمة السلامة - فرع الحمراء الدمام',
      category: 'أنظمة السلامة',
      location: 'الدمام - الحمراء',
      area: 'نظام متكامل',
      description: 'توريد وتركيب وفحص وتشغيل خزان ومضخة حريق شاملاً جميع التمديدات لصناديق الحريق وفحص جميع أنظمة الحريق',
      image: 'https://readdy.ai/api/search-image?query=Fire%20safety%20system%20installation%20in%20commercial%20building%2C%20fire%20water%20tank%20and%20pump%20with%20complete%20piping%20network%2C%20modern%20fire%20protection%20infrastructure%20with%20fire%20hose%20cabinets%2C%20corporate%20construction%20photography%20with%20technical%20details&width=800&height=600&seq=project-fire-system-dammam-004&orientation=landscape',
      slug: 'fire-system-dammam-hamra'
    },
    {
      id: 5,
      title: 'أنظمة السلامة - فرع الخليج الدمام',
      category: 'أنظمة السلامة',
      location: 'الدمام - الخليج',
      area: 'نظام متكامل',
      description: 'توريد وتركيب وفحص وتشغيل خزان ومضخة حريق شاملاً جميع التمديدات وفحص جميع أنظمة الحريق وصيانتها',
      image: 'https://readdy.ai/api/search-image?query=Complete%20fire%20protection%20system%20in%20modern%20commercial%20facility%2C%20fire%20suppression%20equipment%20with%20water%20tanks%20pumps%20and%20distribution%20network%2C%20professional%20fire%20safety%20installation%2C%20corporate%20construction%20photography%20with%20professional%20quality&width=800&height=600&seq=project-fire-system-khaleej-005&orientation=landscape',
      slug: 'fire-system-dammam-khaleej'
    },
    {
      id: 6,
      title: 'أنظمة السلامة - فرع الثقبة الخبر',
      category: 'أنظمة السلامة',
      location: 'الخبر - الثقبة',
      area: 'نظام متكامل',
      description: 'توريد وتركيب وفحص وتشغيل خزان ومضخة حريق شاملاً جميع التمديدات لصناديق الحريق وفحص وصيانة الأنظمة',
      image: 'https://readdy.ai/api/search-image?query=Fire%20safety%20infrastructure%20installation%20project%2C%20modern%20fire%20protection%20system%20with%20tanks%20pumps%20and%20piping%2C%20comprehensive%20fire%20safety%20equipment%20in%20commercial%20building%2C%20corporate%20construction%20photography%20with%20technical%20precision&width=800&height=600&seq=project-fire-system-thuqbah-006&orientation=landscape',
      slug: 'fire-system-khobar-thuqbah'
    },
    {
      id: 7,
      title: 'أنظمة السلامة - فرع رأس تنورة',
      category: 'أنظمة السلامة',
      location: 'رأس تنورة',
      area: 'نظام متكامل',
      description: 'توريد وتركيب وفحص وتشغيل خزان ومضخة حريق شاملاً جميع التمديدات وفحص جميع أنظمة الحريق وصيانتها',
      image: 'https://readdy.ai/api/search-image?query=Advanced%20fire%20protection%20system%20installation%2C%20industrial%20fire%20safety%20equipment%20with%20water%20storage%20and%20pumping%20systems%2C%20complete%20fire%20suppression%20infrastructure%2C%20corporate%20construction%20photography%20with%20professional%20quality&width=800&height=600&seq=project-fire-system-ras-tanura-007&orientation=landscape',
      slug: 'fire-system-ras-tanura'
    },
    {
      id: 8,
      title: 'مشروع إنشاءات متكامل',
      category: 'الإنشاءات',
      location: 'الرياض',
      area: '1500 متر مربع',
      description: 'مشروع إنشاءات متكامل يشمل البناء والتشييد والأعمال الميكانيكية والكهربائية والمدنية',
      image: 'https://readdy.ai/api/search-image?query=Large-scale%20integrated%20construction%20project%2C%20modern%20commercial%20building%20under%20construction%20with%20steel%20framework%2C%20comprehensive%20construction%20work%20including%20mechanical%20electrical%20and%20civil%20works%2C%20corporate%20construction%20photography%20with%20professional%20quality&width=800&height=600&seq=project-integrated-construction-008&orientation=landscape',
      slug: 'integrated-construction-riyadh'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#202835] shadow-lg' : 'bg-[#202835]'}`}>
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-between h-24">
            <Link className="flex items-center" to="/">
              <img 
                alt="شركة الهمة الذهبية" 
                className="h-16 w-auto" 
                src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/c39a188db929712e2f2919bb54dee404.png"
              />
            </Link>

            <nav className="hidden lg:flex items-center gap-8">
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/">
                الرئيسية
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/about">
                من نحن
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/services">
                الخدمات
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group text-[#d4af37]" to="/projects">
                المشاريع
                <span className="absolute bottom-0 right-0 w-full h-0.5 bg-[#d4af37]"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/news">
                الأخبار
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
            </nav>

            <Link className="hidden lg:block px-8 py-3 bg-[#d4af37] text-white font-bold rounded-full hover:bg-[#c19b2e] transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer" to="/contact">
              تواصل معنا
            </Link>

            <button 
              className="lg:hidden text-white text-2xl w-10 h-10 flex items-center justify-center cursor-pointer"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden bg-[#202835] border-t border-white/10">
            <nav className="container mx-auto px-6 py-4 flex flex-col gap-4">
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/">الرئيسية</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/about">من نحن</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/services">الخدمات</Link>
              <Link className="text-white font-semibold text-[#d4af37] transition-colors" to="/projects">المشاريع</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/news">الأخبار</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/contact">تواصل معنا</Link>
            </nav>
          </div>
        )}
      </header>

      {/* Hero Section */}
      <section className="relative h-[60vh] w-full overflow-hidden mt-24">
        <div className="absolute inset-0 w-full h-full">
          <img 
            alt="مشاريع شركة الهمة الذهبية" 
            className="w-full h-full object-cover object-center" 
            src="https://readdy.ai/api/search-image?query=Portfolio%20of%20completed%20construction%20projects%20showcase%2C%20multiple%20successful%20construction%20and%20renovation%20projects%2C%20professional%20construction%20company%20achievements%20banner%2C%20corporate%20photography%20with%20professional%20quality&width=1920&height=1080&seq=projects-hero-banner-001&orientation=landscape"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#202835]/80 via-[#202835]/70 to-[#202835]/80"></div>
        </div>
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="container mx-auto px-6 text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">مشاريعنا</h1>
            <div className="w-20 h-1 bg-[#d4af37] mx-auto mb-6"></div>
            <p className="text-xl text-white/90 max-w-3xl mx-auto">
              نفخر بإنجازاتنا ومشاريعنا المتميزة في مختلف المجالات
            </p>
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-32 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((project) => (
              <Link
                key={project.id}
                to={`/projects/${project.slug}`}
                className="group bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full h-[280px] overflow-hidden">
                  <img
                    alt={project.title}
                    className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                    src={project.image}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#202835]/90 to-transparent"></div>
                  <div className="absolute bottom-4 right-4 left-4">
                    <span className="inline-block px-4 py-2 bg-[#d4af37] text-white text-sm font-semibold rounded-full mb-2">
                      {project.category}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-[#202835] mb-3 line-clamp-2 group-hover:text-[#d4af37] transition-colors">
                    {project.title}
                  </h3>
                  <div className="space-y-2 mb-4">
                    <div className="flex items-center gap-2 text-[#202835]/60 text-sm">
                      <i className="ri-map-pin-line text-[#d4af37]"></i>
                      <span>{project.location}</span>
                    </div>
                    <div className="flex items-center gap-2 text-[#202835]/60 text-sm">
                      <i className="ri-ruler-line text-[#d4af37]"></i>
                      <span>{project.area}</span>
                    </div>
                  </div>
                  <p className="text-[#202835]/70 leading-relaxed mb-4 line-clamp-2">
                    {project.description}
                  </p>
                  <div className="flex items-center gap-2 text-[#d4af37] font-semibold group-hover:gap-3 transition-all duration-300">
                    <span>عرض التفاصيل</span>
                    <i className="ri-arrow-left-line"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative bg-[#202835] text-white overflow-hidden">
        <div className="container mx-auto px-6 relative z-10">
          <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
            <div>
              <Link className="inline-block mb-6" to="/">
                <img 
                  alt="شركة الهمة الذهبية" 
                  className="h-16 w-auto" 
                  src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/c39a188db929712e2f2919bb54dee404.png"
                />
              </Link>
              <p className="text-white/80 leading-relaxed mb-6">
                شركة الهمة الذهبية، شريكك الموثوق في عالم المقاولات والإنشاءات.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-6">روابط سريعة</h3>
              <ul className="space-y-3">
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/about">من نحن</Link></li>
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/services">الخدمات</Link></li>
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/projects">المشاريع</Link></li>
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/news">الأخبار</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-6">خدماتنا</h3>
              <ul className="space-y-3">
                <li className="text-white/80">الإنشاءات والبناء</li>
                <li className="text-white/80">الترميم والصيانة</li>
                <li className="text-white/80">الأعمال الكهربائية</li>
                <li className="text-white/80">أنظمة السلامة</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-6">تواصل معنا</h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3 text-white/80">
                  <i className="ri-phone-line text-[#d4af37] text-xl mt-1"></i>
                  <div>
                    <div dir="ltr">+966 50 016 5920</div>
                    <div dir="ltr">+966 50 125 5250</div>
                  </div>
                </li>
                <li className="flex items-start gap-3 text-white/80">
                  <i className="ri-mail-line text-[#d4af37] text-xl mt-1"></i>
                  <span>info@gmcc.com.sa</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 py-6">
            <p className="text-white/60 text-sm text-center">
              © 2024 شركة الهمة الذهبية. جميع الحقوق محفوظة.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
